import React, { useRef } from 'react';
import './styles/global.css';
import FloatingBackground from './components/FloatingBackground';
import ScrollPath from './components/ScrollPath';
import Navigation from './components/Navigation';
import Hero from './sections/Hero';
import About from './sections/About';
import Skills from './sections/Skills';
import Projects from './sections/Projects';
import Experience from './sections/Experience';
import Contact from './sections/Contact';


function App() {
  const projectsRef = useRef(null);

  const handleProjectsClick = () => {
    if (projectsRef.current) {
      projectsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <FloatingBackground />
      <ScrollPath />
      <Navigation />
      <Hero onProjectsClick={handleProjectsClick} />
      <About />
      <Skills />
      <div ref={projectsRef}>
        <Projects />
      </div>
      <Experience />
      <Contact />
    </div>
  );
}

export default App;
